import React, { forwardRef, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
//import jsPDF from "jspdf";

//Services
import * as Service from "../../../services/Service.js";
import Constants from "../../../services/Constants.js";
import swal from "sweetalert";
//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Typography,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';

import {
  KeyboardTimePicker,
} from "components/pickers";

//import ReactExport from "react-data-export";

import { useTranslation } from "react-i18next";

//import XLSX from "xlsx";
//import FileSaver from "file-saver";
import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import * as api from "../../../actions/api.js";
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, ViewList, preview, Edit } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { cellFocusEditor } from "../../../services/Common.js";

import { fr, enGB } from "date-fns/locale"; // import French and English locale
import { format, subDays } from 'date-fns';
import {
  getFacilityListByGroup,
  getNationalMOSRangeListByGroup,
} from "../../../services/Common.js";
import encryptionService from "../../../services/encryptionService";    

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const IssueDetails = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const FacilityId = localStorage.getItem("FacilityId");
  console.log("FacilityId: ", FacilityId);
  const FacilityName = localStorage.getItem("FacilityName");
  const menukey = "issue-details";
  const UserInfo = encryptionService.decryptUserInfo();
  const userId = UserInfo == 0 ? "" : UserInfo[0].id;
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const DefaultFacilityId = localStorage.getItem("DefaultFacilityId");
  console.log("DefaultFacilityId: ", DefaultFacilityId);

  const IsAllFacility = UserInfo == 0 ? "" : UserInfo[0].IsAllFacility;

  const assignedProdGroupList = UserInfo[0].ItemGroupId.split(",");
  const [prodGroupCountUnderRole, setProdGroupCountUnderRole] = React.useState(
    assignedProdGroupList.length,
  );
  const RoleItemGroupId = UserInfo == 0 ? "" : assignedProdGroupList[0];
  /* const RoleItemGroupId = UserInfo == 0 ? "" : UserInfo[0].ItemGroupId; */

  // const MosTypelist = JSON.parse(localStorage.getItem("MosTypelist"));

  const classes = useStyles();
  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;
  const tableRef = useRef();
  const { useState } = React;
  const [selectedRow, setSelectedRow] = useState(null);
  const [productsData, selectProductsData] = useState([]);
  const [productsAllData, selectProductsAllData] = useState([]);
  const [productGroupData, selectProductGroupData] = useState([]);
  const [productGroupFilter, selectProductGroupFilter] = useState("0");
  const [firstLoad, setFirstLoad] = useState(true);
  const [numberRowPerPage, setNumberRowPerPage] = useState(5);
  const [totalRow, setTotalRow] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [query, setQuery] = useState("");

  const [TableDataUpdate, setTableDataUpdate] = useState([]);
  const [ManyJsonSave, setInputChange] = useState({});
  const [radioValue, setRadioValue] = useState(2);
  const [isStockAvailable, setIsStockAvailable] = useState(0);
  const [dataItems, setDataItems] = useState([]);

  const ProductGroupList = JSON.parse(localStorage.getItem("ProductGroupList"));
  //const [currProductGroupId, setCurrProductGroupId] = useState(ProductGroupList[0].id);
  const [currProductGroupId, setCurrProductGroupId] = useState(RoleItemGroupId);

  const [FacilityList, setFacilityList] = useState(
    getSobapsWH(getFacilityListByGroup(RoleItemGroupId)),
  );
  const isFacilityIdFound = FacilityList.some(
    (facility) => facility.id == FacilityId,
  );
  const [currFacilityId, setCurrFacilityId] = useState(
    isFacilityIdFound ? FacilityId : "",
  );

  const handleProductGroupChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setFirstLoad(true);
    setLoading(true);

    setCurrProductGroupId(rowId);

    const newFacilityList = getFacilityListByGroup(rowId);
    // console.log("newFacilityList: ", newFacilityList);

    const fList = getSobapsWH(newFacilityList);
    // console.log("fList: ", fList);

    setFacilityList(fList);

    const isFacilityIdFound = fList.some(
      (facility) => facility.id == DefaultFacilityId,
    );
    // console.log("isFacilityIdFound: ", isFacilityIdFound);
    // console.log("DefaultFacilityId DefaultFacilityId: ", DefaultFacilityId);
    setCurrFacilityId(isFacilityIdFound ? DefaultFacilityId : "");
  };

  function getSobapsWH(newFacilityList) {
    const fList = newFacilityList.filter((facility) => {
      return facility.FLevelId == 1 || facility.FLevelId == 2;
      //&& facility.SOBAPSCode!= '' && facility.SOBAPSCode!= null ;
    });

    return fList;
  }
  const handleFacilityChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setFirstLoad(true);
    setLoading(true);

    setCurrFacilityId(rowId);
  };

  React.useEffect(() => {
    localStorage.setItem("FacilityId", currFacilityId);
  }, [currFacilityId]);

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(subDays(new Date(), 90), 'yyyy-MM-dd'),
  );

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    format(new Date(), 'yyyy-MM-dd'),
  );

  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();

  let params = {
    menukey: menukey,
    FacilityId: currFacilityId,
    action: "getDataList",
    StartDate: selectedStartDate,
    EndDate: selectedEndDate,
    ItemGroupId: currProductGroupId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    RadioValue: radioValue,
  };

  const [isLoading, setLoading] = useState(false);

  const {
    error,
    isError,
    data,
    refetch: stockData,
  } = useQuery(
    [params],
    api.getissuedetailsreport,
    {
      onSuccess: (data) => {
        if (firstLoad) {
          localStorage.setItem("StockData", JSON.stringify(data));
          setDataItems(data);
          setIsStockAvailable(data[0]?.IsStockAvailable || 0);
          setLoading(false);
          setFirstLoad(false);
        }
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    },
    {
      refetchOnWindowFocus: false,
      enabled: true,
    },
  );

  // const setUpdatedDetailsGridDataHandler = (rows) => {
  //   const updateTableData = data.map((row) => {
  //     return row;
  //   });
  // };

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let formatedDate = format(new Date(selectedStartDate), 'yyyy-MM-dd');
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let currFacilityName =
      FacilityList.find((Facility_List) => Facility_List.id == currFacilityId)?.name ?? "";

    window.open(
      finalUrl +
        "?action=IssueDetailsExcelExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&StartDate=" +
        formatedDate +
        "&EndDate=" +
        format(new Date(selectedEndDate), 'yyyy-MM-dd') +
        "&FacilityId=" +
        currFacilityId +
        "&RadioValue=" +
        radioValue +
        "&FacilityName=" +
        encodeURIComponent(currFacilityName) +
        "&RoleItemGroupId=" +
        RoleItemGroupId +
        "&ItemGroupId=" +
        currProductGroupId +
        "&TimeStamp=" +
        Date.now(),
    );
  };
  /* =====End of Excel Export Code==== */

  const columns = [
    {
      title: "Id",
      field: "id",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: 75,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Issue Date"]),
      field: "TransactionDate",
      headerFilter: true,
      width: 110,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == null ? "" : format(new Date(value), 'dd/MM/yyyy');
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Issue Invoice No"]),
      field: "TransactionNo",
      headerFilter: true,
      width: 160,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Recipient"]),
      field: "IssuedToFacilityName",
      headerFilter: true,
      width: 130,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order No"]),
      field: "SupplierInvNo",
      headerFilter: true,
      width: 140,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order Date"]),
      field: "SupplierInvDate",
      headerFilter: true,
      width: 110,

      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == null ? "" : format(new Date(value), 'dd/MM/yyyy');
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Code"]),
      field: "ProductCode",
      headerFilter: true,
      width: 115,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Name"]),
      field: "ProductName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Quantity"]),
      field: "Quantity",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 110,
    },
        {
      title: t(DispensingLanguage[lan][menukey]["Unit Price (CFA)"]),
      field: "UnitPrice",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 110,
    },
        {
      title: t(DispensingLanguage[lan][menukey]["Line Total"]),
      field: "LineTotalPrice",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 110,

      formatter: "money",
    },
    // {
    //   title: t(DispensingLanguage[lan][menukey]["Actions"]),
    //   field: "custom",
    //   headerSort: false,
    //   hozAlign: "center",
    //   headerHozAlign: "center",
    //   width: 80,
    //   formatter: reactFormatter(<ActionButton />),
    // },
  ];

  // function ActionButton(props) {
  //   const rowData = props.cell._cell.row.data;
  //   // console.log(props.cell._cell.row);
  //   //const cellValue = props.cell._cell.value || 'Edit | Show';
  //   return (
  //     <>
  //       <ViewList
  //         onClick={() => {
  //           dataItems.forEach((row, i) => {
  //             if (rowData.ItemNo == row.ItemNo) {
  //               localStorage.setItem("StockDataIndex", JSON.stringify(i));
  //               editUser(rowData);
  //               return;
  //             }
  //           });
  //         }}
  //       />
  //     </>
  //   );
  // }

  const handleStartDateChange = (date) => {
    setFirstLoad(true);
    setLoading(true);
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setFirstLoad(true);
    setLoading(true);
    setSelectedEndDate(date);
  };

  const handleChangePage = (data) => {
    setPageNumber(data);
    setFirstLoad(false);
  };
  const handleChangeRowPerPage = (data) => {
    setNumberRowPerPage(data);
  };

  const checkLogin = () => {
    let token = Constants.token;

    if (!token) {
      swal("Oops!", `token expired. Please login again`, "error");
      props.history.push("/login");
    }
  };
  const editUser = (data, dataItemss) => {
    let route = `issue-details/edit/${data.ItemNo}`;
    props.history.push(route);
  };

  // const changeRadio = (value) => {
  //   setFirstLoad(true);
  //   setLoading(true);
  //   setRadioValue(value);
  // };

  React.useEffect(() => {
    setLoading(true);
    stockData();
  }, []);


  
  return (
    <>
      <div className={classes.productPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Issue Details"]}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                  <Grid container justifyContent="space-around">
                    <DatePicker
                      // disabled={true}
                      inputFormat="dd/MM/yyyy"
                      label={DispensingLanguage[lan][menukey]["Start Date"]}
                      value={selectedStartDate}
                      onChange={handleStartDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                          id="date-picker-inline"
                        />
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>

              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                  <Grid container justifyContent="space-around">
                    <DatePicker
                      // disabled={true}
                      inputFormat="dd/MM/yyyy"
                      label={DispensingLanguage[lan][menukey]["End Date"]}
                      value={selectedEndDate}
                      onChange={handleEndDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                          id="date-picker-inline"
                        />
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>

              <Grid item xs={2} sm={2}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    className="sw_chosen_filter"
                    id="ProductGroupList"
                    disableClearable
                    //disabled={userId == 1 ? false : true}
                    disabled={prodGroupCountUnderRole > 1 ? false : true}
                    options={ProductGroupList}
                    onChange={(event, newValue) =>
                      handleProductGroupChange(event, newValue)
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                      value={
                      (ProductGroupList.find(
                          (productGroupList) =>
                            productGroupList.id == currProductGroupId,
                        ) ?? null)
                    }
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          DispensingLanguage[lan][menukey]["Product Group"]
                        }
                        variant="standard"
                        hiddenLabel
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={3} sm={3}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    className="sw_chosen_filter"
                    id="FacilityList"
                    disableClearable
                    disabled={IsAllFacility == 1 ? false : true}
                    options={FacilityList}
                    value={
                      FacilityList.find(
                        (facility) => facility.id == currFacilityId,
                      ) || null
                    }
                    onChange={(event, newValue) =>
                      handleFacilityChange(event, newValue)
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={DispensingLanguage[lan][menukey]["Facility"]}
                        variant="standard"
                        hiddenLabel
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              {/* <Grid item xs={3} sm={3}> */}
                {/* <FormControl component="fieldset" className="mt-3 ms-3">
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="row-radio-buttons-group"
                    defaultValue="SHOW_NONE_ZERO"
                  >
                    <FormControlLabel
                      value="SHOW_ALL"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["SHOW ALL"]}
                      onClick={() => changeRadio(0)}
                    />
                    <FormControlLabel
                      value="SHOW_ZERO"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["SHOW ZERO"]}
                      onClick={() => changeRadio(1)}
                    />
                    <FormControlLabel
                      value="SHOW_NONE_ZERO"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["SHOW NONE-ZERO"]}
                      onClick={() => changeRadio(2)}
                    />
                  </RadioGroup>
                </FormControl> */}
              {/* </Grid> */}

              <Grid item xs={3} sm={3}>
                <div className="float-end sw_btn_control">
                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("print")}
                  >
                    <i className="fas fa-print"></i>
                  </Button>

                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("excel")}
                  >
                    <i className="far fa-file-excel"></i>
                  </Button>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}

          <div className="uniqueName">
            <ReactTabulator
              onRef={(r) => { tblRef.table = r.current; }}
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height="550px"
              // events={{
              //   rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              // }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default IssueDetails;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
